import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/reset-password", data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Server error");
    }
  }
);

export const verifyToken = createAsyncThunk(
  "auth/verifyToken",
  async (token, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/reset-password/${token}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Server error");
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    loading: false,
    tokenValid:null,
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(resetPassword.pending, (state) => {
      state.loading = true;
    })
    .addCase(resetPassword.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(resetPassword.rejected, (state) => {
      state.loading = false;
    })
    .addCase(verifyToken.pending, (state) => {
      state.loading = true;
    })
    .addCase(verifyToken.fulfilled, (state, action) => {
      state.loading = false;
      state.tokenValid = action.payload?.status;
    })
    .addCase(verifyToken.rejected, (state) => {
      state.loading = false;
      state.tokenValid = false;
    });
  },
});

export const { resetStatus } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
